import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=8baa3fe0"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports